import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './i18n';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import WhySection from './components/WhySection';
import HowItWorksSection from './components/HowItWorksSection';
import SafetySection from './components/SafetySection';
import TestimonialsSection from './components/TestimonialsSection';
import InfoCardsSection from './components/InfoCardsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import TripFormPage from './components/TripFormPage';
import TransporterRegisterPage from './components/TransporterRegisterPage';
import TransporterLoginPage from './components/TransporterLoginPage';
import TransporterForgotPasswordPage from './components/TransporterForgotPasswordPage';
import ResetPasswordPage from './components/ResetPasswordPage';
import EmailVerificationPage from './components/EmailVerificationPage';
import TransporterDashboard from './components/TransporterDashboard';
import CustomerQuotesPage from './components/CustomerQuotesPage';
import CustomerDashboard from './components/CustomerDashboard';
import CustomerRegisterPage from './components/CustomerRegisterPage';
import CustomerLoginPage from './components/CustomerLoginPage';
import PaymentRedirectPage from './components/PaymentRedirectPage';
import PaymentResultPage from './components/PaymentResultPage';
import AdminPanel from './components/AdminPanel';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import AppRedirectPage from './components/AppRedirectPage';
import ScrollToTop from './components/ScrollToTop';
import ChatWidget from './components/ChatWidget';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <WhySection />
      <HowItWorksSection />
      <SafetySection />
      <TestimonialsSection />
      <InfoCardsSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/trip-form" element={<TripFormPage />} />
          <Route path="/get-quotes" element={<TripFormPage />} />
          <Route path="/my-quotes" element={<CustomerQuotesPage />} />
          <Route path="/dashboard" element={<CustomerDashboard />} />
          <Route path="/my-trips" element={<CustomerDashboard />} />
          <Route path="/customer/register" element={<CustomerRegisterPage />} />
          <Route path="/customer/login" element={<CustomerLoginPage />} />
          <Route path="/payment/:quoteId" element={<PaymentRedirectPage />} />
          <Route path="/payment-result" element={<PaymentResultPage />} />
          <Route path="/drivers" element={<TransporterRegisterPage />} />
          <Route path="/drivers/login" element={<TransporterLoginPage />} />
          <Route path="/drivers/forgot-password" element={<TransporterForgotPasswordPage />} />
          <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
          <Route path="/app/reset-password" element={<AppRedirectPage />} />
          <Route path="/app/magic-link" element={<AppRedirectPage />} />
          <Route path="/drivers/dashboard" element={<TransporterDashboard />} />
          <Route path="/verify-email" element={<EmailVerificationPage />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        </Routes>
        <ChatWidget />
      </BrowserRouter>
    </div>
  );
}

export default App;
